import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Descriptions,
  Card,
} from 'antd';
import ReactJson from 'react-json-view';

import { getGatewayIpnById } from '../../../redux/actions/Gateway';

const TransactionDetails = () => {
  const dispatch = useDispatch();
  const { ipnId, serviceType } = useParams();
  const { gateway_ipn: { data } } = useSelector(({ gateway }) => gateway);

  useEffect(() => {
    if (ipnId) {
      dispatch(getGatewayIpnById(ipnId, serviceType));
    }
  }, [dispatch, ipnId, serviceType]);

  const genUi = (info) => {
    const array = [];
    Object.entries(info).forEach((item) => {
      const key_ = item[0].replace('_', ' ');
      const label = key_.charAt(0).toUpperCase() + key_.slice(1);
      if (!(item[0] === '_id' || item[0] === '_v')) {
        array.push({ label, value: item[1], type: item[1] ? typeof item[1] : 'null' });
      }
    });

    return array;
  };

  return data && data._id ? (
    <div>
      <div className="justify-content-center">
        <Card title={data.account}>
          <Descriptions>
            {genUi(data).map((item) => {
              if (item.type === 'object') {
                return (
                  <Descriptions.Item label={item.label} span={3}>
                    <ReactJson src={item.value} collapsed />
                  </Descriptions.Item>
                );
              }
              return <Descriptions.Item label={item.label}>{`${item.value}`}</Descriptions.Item>;
            })}
          </Descriptions>
        </Card>
      </div>
    </div>
  ) : '';
};

export default TransactionDetails;
